// extracted by mini-css-extract-plugin
export default {"wrapper":"ViewTitle_wrapper__ONvW9","layout":"ViewTitle_layout__EhCVq","text":"ViewTitle_text__l5wUQ"};